import { SelectItem } from 'components/shared/input'
import { BaseEntity, BaseSearchForm } from 'entities'

export type ReagentKind = 'purification' | 'rna_spike_in' | 'ethanol' | 'free_water' | 'library' | 'rt_spike_in' | 'master_mix' | 'other'
export const REAGENT_KIND: ReagentKind[] = ['purification', 'rna_spike_in', 'ethanol', 'free_water', 'library', 'rt_spike_in', 'master_mix', 'other']
export const REAGENT_KIND_SELECT_ITEM: SelectItem[] = REAGENT_KIND.map((i) => {
    return { label: i.toUpperCase(), value: i }
})

export type Reagent = BaseEntity & {
    name?: string
    preservation?: string
    kind?: ReagentKind
    itemCount?: number
}

export type ReagentForm = Reagent

export type ReagentSearchForm = BaseSearchForm & {
    id?: string
}
